module.exports = __webpack_public_path__ + "img/cobadulu.433796f7.svg";